const Blog = [
  {
    image: "",
    name: "Therapiya",
    description:
      " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quidem, inventore.",
  },
  {
    image: "",
    name: "Tkaleem",
    description:
      " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quidem, inventore.",
  },
  {
    image: "",
    name: "moon",
    description:
      " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quidem, inventore.",
  },
];
export default Blog;
